import { SimpleUserModel } from './../../../models/user/simple-user.model';
import { ICustomColorScheme } from './../../../modules/smart-report/components/model/smart-report.model';
import { UserStore } from './../../../services/stores/user.store';
import { ProjectService } from './../../../services/project.service';
import { IProjectAllocationChartData, IProjectStatusData, IProjectMetrics, ICurrentWorkingProjectData } from './../../../models/project/project-dashboard.model';
import { IProjectModel } from './../../../models/project/project.model';
import { AppModes } from '../../../modules/catch-core/data/enum/app-name.enum';
import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { DashboardHelper } from '../../../services/dashboard.service';
import { NextgenApplicationModel } from '../../../models/child-application/nextgen-application.model';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { OrganizationStore } from '../../../services/stores/organization.store';
import { PermissionService } from '../../../services/permission.service';
import { ExternalLinkStore } from '../../../services/stores/external-link.store';
import { IExternalLink } from '../../../models/child-application/externallink.model';
import { IAppModel } from '../../../models/application.model';
import { ApplicationStore } from '../../../services/stores/application.store';
import { BaseComponent } from '../../base/base.component';
import { UiStateStore } from '../../../services/stores/ui-state.store';
import { OTHER } from '../../../modules/catch-core/data/constants/app.constants';
import { STATUS_IN_PROGRESS, STATUS_NEW, STATUS_COMPLETED } from '../../../modules/catch-core/data/constants/filter.constants';
import { isFranklyProductType } from '../../../modules/catch-core/data/helpers/product-type.helper';
import { ProjectStore } from '../../../services/stores/projects.store';
import { IYouTubeVideoModel } from '../../../models/global-setting/global-setting.model';
import { GlobalSettingStore } from '../../../services/stores/global-setting.store';
import { MatTableDataSource } from '@angular/material/table';
import { combineLatest } from 'rxjs';
@Component({
  selector: 'app-animals-dashboard',
  templateUrl: './animals-dashboard.component.html',
  styleUrls: ['./animals-dashboard.component.css'],
  standalone: false,
})
export class AnimalsDashboardComponent extends BaseComponent implements OnInit, AfterViewInit {
  animals: NextgenApplicationModel[] = [];
  animalsTable: any = [[]];
  maxCol = 4;
  hasPermissionToModify = false;

  appTypes: IAppModel[] | any = [];
  public isVideoPanelVisible: boolean = true;
  public subscribers: any = {};
  public videoList: IYouTubeVideoModel[] = [];
  public projectList: IProjectModel[] = [];
  public sortedData!: IProjectModel[];
  public dataSourcePaged!: MatTableDataSource<any>;
  public projectAllocationChartData: IProjectAllocationChartData[] = [];
  public projectStatusData!: IProjectStatusData;
  public currentWorkingProjectData!: ICurrentWorkingProjectData;
  public userList: SimpleUserModel[] = [];
  public isLoading$ = this.projectStore.$isProjectListLoading;
  public colorTheme: ICustomColorScheme[] = [
    { name: STATUS_IN_PROGRESS, value: '#C1CFE9' },
    { name: STATUS_COMPLETED, value: '#6DBD4A' },
    { name: STATUS_NEW, value: '#6C7481' },
  ];
  public projectMetrics: IProjectMetrics = {
    averageCompletionDays: 0,
    newProjectMonthCount: 0,
    projectCompletionCountMonth: 0,
    projectCompletionCountYear: 0,
  };

  constructor(
    private dashboradHelper: DashboardHelper,
    private activeRoute: ActivatedRoute,
    private uiStateStore: UiStateStore,
    private organizationStore: OrganizationStore,
    private permissionService: PermissionService,
    private cdr: ChangeDetectorRef,
    private externalLinkStore: ExternalLinkStore,
    private appStore: ApplicationStore,
    private projectStore: ProjectStore,
    private globalSettingStore: GlobalSettingStore,
    private projectService: ProjectService,
    private userStore: UserStore,
    private router: Router,
  ) {
    super();
  }

  ngAfterViewInit() {
    this.dashboradHelper.setShowGraphPanel(false);

    if (this.permissionService.isSysAdmin) {
      this.hasPermissionToModify = true;
    }
    // this.subscribers.users = this.userStore.$users.subscribe((u) => {
    //   if (u && u.count() > 0) {
    //     this.userList = u.toArray();
    //     //console.log('users', this.userList);
    //   }
    // });
    this.subscribers.dataSubscription = combineLatest([this.projectStore.$projects, this.userStore.$projectOwnerCandidates]).subscribe(
      ([projects, users]) => {
        if (projects.count() > 0 && users) {
          this.projectList = projects.toArray();
          this.userList = users.toArray();
          const inactiveUsers = this.userList.filter((u) => !u.isActive);
          console.log(inactiveUsers);
          this.prepareProjectData();
          this.cdr.detectChanges();
        }
      },
      (err) => {
        console.error(err);
      },
    );

    this.subscribers.ownerSelection = this.projectService.projectAllocationSelectedOwner.subscribe((event) => {
      if (event && event.fullName) {
        this.router.navigate(['/', 'dashboard', { outlets: { mainPanel: ['projectsview'] } }], { queryParamsHandling: 'preserve' });
      }
    });

    //@todo - later this should move to service
  }

  ngOnInit() {
    this.dashboradHelper.setShowLeftSidePanel(false);
    this.dashboradHelper.setCurrentAppMode(AppModes.CatchHub);

    this.animals = [];
    this.projectStore.loadInitialData();
    // this.subscribers.projects = this.projectStore.$projects.subscribe(
    //   (projects) => {
    //     if (projects) {
    //       if (projects.isEmpty()) {
    //         // there are no projects in the organization yet
    //         // this.isLoading = false;
    //       }
    //       this.projectList = projects.toArray();

    //       // const allProjectData = this.projectService.prepareAllProjectData(this.projectList, this.userList);
    //       // this.projectAllocationChartData = allProjectData.projectAllocationChartData;
    //       // this.projectStatusData = allProjectData.projectStatusData;
    //       // this.currentWorkingProjectData = allProjectData.currentWorkingProjectData;
    //       // this.projectMetrics = allProjectData.projectMetrics;

    //       this.prepareProjectData();
    //       this.cdr.detectChanges();
    //     }
    //   },
    //   (err) => {
    //     console.error(err);
    //     // this.isLoading = false;
    //   }
    // );

    this.subscribers.videoList = this.globalSettingStore.$videoList.subscribe((v) => {
      if (v) {
        this.videoList = v.slice(0, 3);
      }
    });

    this.subscribers.firstExternalLink = this.externalLinkStore.$firstExternalLink.subscribe((g) => {
      if (g) {
        let externalLinks = g.externalLinks;
        externalLinks.map((link: any) => {
          if (link.icon && link.icon.attachment && !link.icon.attachment.includes('data:image/png;base64,')) {
            const attachmentString = 'data:image/png;base64,' + link.icon.attachment;
            link.icon.attachment = attachmentString;
          }
        });

        // remove hidden links
        externalLinks = externalLinks.filter((e: any) => (!e.isNextGenMenu || isFranklyProductType(e.productType) || e.productType === 'Other') && e.showInDashBoard && e.active);
        if (this.subscribers.applications) {
          this.subscribers.applications.unsubscribe();
        }
        this.subscribers.applications = this.appStore.$applications.subscribe((a) => {
          if (a) {
            this.uiStateStore.endBackendAction('Loaded products successfully...!');
            this.appTypes = a.productTypes;
            this.dashboradHelper.appTypes = a.productTypes;
            this.animals = this.dashboradHelper.buildSortedApplicationArray(externalLinks);
            // this.buildAppTable();
            this.cdr.detectChanges();
          }
        });
      }
    });

    this.subscribers.url = this.activeRoute.url.subscribe((url: UrlSegment[]) => {
      if (url[0].path === 'animals') {
        this.subscribers.org = this.organizationStore.$firstOrganization.subscribe((org) => {
          if (org) {
            // this.dashboradHelper.setCurrentApplication(org.get('bannerText'));
          }
        });
      }
    });
  }

  onEditApplication(appName: any) {
    // #todo
    //console.log('Edit : ' + appName);
  }

  onDeleteApplication(appName: any) {
    // #todo
    //console.log('Delete : ' + appName);
  }

  onAddApplication() {
    // #todo
    //console.log('add new app ......... : ');
  }

  onLoadApplication(app: IExternalLink) {
    if (isFranklyProductType(app?.productType)) {
      // this.projectStore.loadInitialData();
    }
    if (app?.productType === OTHER) {
      if (app && app.url !== '') {
        this.dashboradHelper.loadApplication(app);
      }
      return true;
    }
    this.setCurrentAnimal(app);
    if (app) {
      this.dashboradHelper.loadApplication(app);
    }
  }
  public hideVideoList() {
    this.isVideoPanelVisible = false;
  }

  private setCurrentAnimal(loadAnimal: any) {
    if (!loadAnimal.isExternal) {
      this.dashboradHelper.currentETApplication = loadAnimal;
    }
  }
  private prepareProjectData(): void {
    if (!this.projectList || this.projectList.length === 0) {
      console.warn('Project list is empty. Skipping data preparation.');
      return;
    }

    if (this.userList.length === 0 || !this.userList) {
      console.warn('User list is empty. This may affect project allocation data.');
    }

    try {
      const allProjectData = this.projectService.prepareAllProjectData(this.projectList, this.userList);

      if (allProjectData) {
        this.projectAllocationChartData = allProjectData.projectAllocationChartData || [];
        this.projectStatusData = allProjectData.projectStatusData || null;
        this.currentWorkingProjectData = allProjectData.currentWorkingProjectData || null;
        this.projectMetrics = allProjectData.projectMetrics || {
          averageCompletionDays: 0,
          newProjectMonthCount: 0,
          projectCompletionCountMonth: 0,
          projectCompletionCountYear: 0,
        };
      } else {
        console.error('prepareAllProjectData returned null or undefined');
      }
    } catch (error) {
      console.error('Error preparing project data:', error);
    }
  }
}
